module.exports = __webpack_public_path__ + "static/media/Clipboard.437b6894.svg";